import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useAnonAuth = () => {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const initAnonAuth = async () => {
      const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
      if (sessionError) console.error("❌ Session error:", sessionError);

      if (sessionData?.session) {
        const token = sessionData.session.access_token;
        localStorage.setItem("supabase_token", token);
        setToken(token);
      } else {
        const { data, error } = await supabase.auth.signInAnonymously();
        if (error) {
          toast.error("Auth failed. Please refresh the page.");
          console.error(error);
          return;
        }
        const token = data.session?.access_token || null;
        localStorage.setItem("supabase_token", token!);
        setToken(token);
      }
    };

    initAnonAuth();
  }, []);

  return token;
};
